import { MarkerClusterer } from '@googlemaps/markerclusterer';

const init = () => {
    var map;

    function initMap() {
        map = new google.maps.Map(document.getElementById("map"), {
            zoom: 4,
            center: { lat: -25.267985828286363, lng: 134.0973767099238 },
            streetViewControl: false,
            mapTypeControl: false,
            styles: [
                { "featureType": "administrative", "elementType": "labels.text.fill", "stylers": [{ "color": "#6195a0" }] },
                { "featureType": "landscape", "elementType": "all", "stylers": [{ "color": "#f2f2f2" }] },
                { "featureType": "landscape", "elementType": "geometry.fill", "stylers": [{ "color": "#ffffff" }] },
                { "featureType": "poi", "elementType": "all", "stylers": [{ "visibility": "off" }] },
                { "featureType": "poi.park", "elementType": "geometry.fill", "stylers": [{ "color": "#e6f3d6" }, { "visibility": "on" }] },
                { "featureType": "road", "elementType": "all", "stylers": [{ "saturation": -100 }, { "lightness": 45 }, { "visibility": "simplified" }] },
                { "featureType": "road.highway", "elementType": "all", "stylers": [{ "visibility": "simplified" }] },
                { "featureType": "road.highway", "elementType": "geometry.fill", "stylers": [{ "color": "#f4d2c5" }, { "visibility": "simplified" }] },
                { "featureType": "road.highway", "elementType": "labels.text", "stylers": [{ "color": "#4e4e4e" }] },
                { "featureType": "road.arterial", "elementType": "geometry.fill", "stylers": [{ "color": "#f4f4f4" }] },
                { "featureType": "road.arterial", "elementType": "labels.text.fill", "stylers": [{ "color": "#787878" }] },
                { "featureType": "road.arterial", "elementType": "labels.icon", "stylers": [{ "visibility": "off" }] },
                { "featureType": "transit", "elementType": "all", "stylers": [{ "visibility": "off" }] },
                { "featureType": "water", "elementType": "all", "stylers": [{ "color": "#eaf6f8" }, { "visibility": "on" }] },
                { "featureType": "water", "elementType": "geometry.fill", "stylers": [{ "color": "#eaf6f8" }] }
            ]
        });

        loadLocationsAndSetMarkers();
    }

    function loadLocationsAndSetMarkers() {
        // Get campaign ID from data attribute or global variable
        const mapElement = document.getElementById("map");
        const campaignId = mapElement.getAttribute('data-campaign-id');
        
        if (!campaignId) {
            console.error('No campaign ID found for map');
            return;
        }

        fetch(`../../api/bookshops/campaign?campaignId=${campaignId}`)
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then(locations => {
                if (locations && locations.length > 0) {
                    setMarkers(locations);
                } else {
                    console.error('No locations found in the JSON file.');
                }
            })
            .catch(error => console.error('Error loading locations:', error));
    }

    function setMarkers(locations) {
        const infowindow = new google.maps.InfoWindow();

        const image = {
            url: "../../img/pin-2.png",
            size: new google.maps.Size(50, 50),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(5, 25),
        };

        const shape = {
            coords: [1, 1, 50, 1, 50, 50, 1, 50],
            type: "poly",
        };

        const markers = locations.map((location, i) => {

            var marker = new google.maps.Marker({
                position: { lat: location.latitude, lng: location.longitude },
                title: location.name,
                icon: image,
                shape: shape
            });

            function isAppleDevice() {
                return /iPad|iPhone|iPod|Macintosh/.test(navigator.userAgent) && !window.MSStream;
            }

            function getAppleMapsLink(address) {
                return `https://maps.apple.com/?q=${encodeURIComponent(address)}`;
            }

            function getGoogleMapsLink(address) {
                return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;
            }

            const trimmedAddress = location.address.trim();

            var windowContent = '<div class="map__infowindow" id="content">'
                + '<h2 class="map__infowindow-name">' + location.name + '</h1>'
                + '<p class="map__infowindow-address">' + trimmedAddress + ', ' + location.suburb + '</p>'
            if (location.website) {
                windowContent += '<a class="map__infowindow-website" href="' + location.website + '">View Website</a>'
            }
            if (isAppleDevice()) {
                windowContent += '<div class="map__infowindow-button-container"><a class="map__infowindow-button" href="' + getAppleMapsLink(location.name + " " + trimmedAddress + ", " + location.postcode) + '" target="_blank">Apple Maps</a>'
                    + '<a class="map__infowindow-button" href="' + getGoogleMapsLink(location.name + " " + trimmedAddress + ", " + location.postcode) + '" target="_blank">Google Maps</a></div>';
            } else {
                windowContent += '<a class="map__infowindow-button" href="' + getGoogleMapsLink(location.name + " " + trimmedAddress + ", " + location.postcode) + '" target="_blank">Google Maps</a>';
            }
            windowContent += '</div>';

            google.maps.event.addListener(marker, 'click', function () {
                map.setCenter(marker.getPosition());
                infowindow.setContent(windowContent);
                infowindow.open(map, marker);
            });

            return marker;
        });

        const clusterIcons = [
            {
                url: '../../img/m1.png', // Custom image for small clusters
                width: 50,
                height: 50,
                textColor: '#ffffff',
                textSize: 12
            },
            {
                url: '../../img/m2.png', // Custom image for medium clusters
                width: 60,
                height: 60,
                textColor: '#ffffff',
                textSize: 14
            },
            {
                url: '../../img/m3.png', // Custom image for large clusters
                width: 70,
                height: 70,
                textColor: '#ffffff',
                textSize: 16
            }
        ];

        const customRenderer = {
            render({ count, position }) {
                let index = 0;
                if (count >= 10) index = 2;
                else if (count >= 5) index = 1;

                return new google.maps.Marker({
                    position,
                    icon: {
                        url: clusterIcons[index].url,
                        scaledSize: new google.maps.Size(clusterIcons[index].width, clusterIcons[index].height),
                    },
                    label: {
                        text: String(count),
                        color: clusterIcons[index].textColor,
                        fontSize: `${clusterIcons[index].textSize}px`
                    }
                });
            }
        };

        new MarkerClusterer({
            map: map,
            markers: markers,
            renderer: customRenderer // Apply custom renderer
        });
    }

    // Initialize map when Google Maps API is loaded
    if (typeof google !== 'undefined' && google.maps) {
        initMap();
    } else {
        // Wait for Google Maps API to load
        window.initMap = initMap;
    }
};

export default init;
